var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocks1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "40px",
    id: "block1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.8 85.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9,50.3v30H5v-30H18.9m5-5H0v40H23.9v-40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8,65.9V80.3h-30V65.9h30m5-5h-40V85.3h40V60.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53,6.19l14.18,4.09A20.89,20.89,0,0,0,52.59,32,21,21,0,0,0,70.7,21.53L84.79,25.6,76.47,54.42,9.21,35,17.53,6.19M14.11,0,3,38.43,79.89,60.61,91,22.18,67.85,15.51a.11.11,0,0,1,0,.05A15.88,15.88,0,0,1,52.59,27a16,16,0,0,1-4.41-.62A15.89,15.89,0,0,1,37.32,6.75a.08.08,0,0,0,0,0L14.11,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.94,66l3.51,13.46H36.55L46.94,66m2.27-11.11L26.36,84.44H56.92L49.21,54.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks1);
export default __webpack_public_path__ + "static/media/blocks1.c9560edce2e8fbc2e4043c500d3d6cef.svg";
export { ForwardRef as ReactComponent };